import styled from 'styled-components';
import {Color} from '../../../../../../common/utils/color-util';
import {PlayRealButtonDefaultBox} from './play-real-button.default.box';

export const PlayRealButtonCasino888Box = styled(PlayRealButtonDefaultBox)`
    background-position: -553px -409px;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    box-shadow: 0 0 0 0 ${(props) => Color.fromHex(props.theme.colors.brandPrimary, 0.5).rgba()};

    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlExact} {
        width: 6rem;
        height: 6rem;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 5rem;
        height: 5rem;
        background-position: -553px -409px;
    }

`;